<template>
  <v-container fluid :class="floatingState === State.Normal ? 'floating-layout' : 'floating-all-layout'">
    <div :class="floatingState === State.Normal ? 'record-off' : 'record-on'">
      <div style="display: flex; height: calc(100% - 110px); padding: 0 24px">
        <div
          :class="
            floatingState === State.Preview
              ? 'wrap-video-preview'
              : floatingState === State.RecordSetting ||
                floatingState === State.CountDown ||
                floatingState === State.Recording
              ? 'wrap-video'
              : 'wrap-non-video'
          "
        >
          <div cols="auto" class="my-2" style="">
            <v-btn plain @click="cancelRecording()" style="padding: 0; min-width: 30px">
              <span class="material-icons-round fw-400 color-gray" style="font-size: 28px" translate="no">close</span>
            </v-btn>
          </div>
          <v-row
            align="center"
            justify="center"
            align-content="center"
            align-self="center"
            align-center
            class="wrap-plus-noti"
            dense
            no-gutters
            v-show="
              userInfo &&
              !wsClipCnt['isWsMember'] &&
              floatingState === State.RecordSetting &&
              wsClipCnt['planType'] !== 'Plus'
            "
          >
            <v-col
              :cols="$vuetify.breakpoint.width < 600 ? '12' : 'auto'"
              :align="$vuetify.breakpoint.width < 600 ? 'center' : 'start'"
            >
              <span class="txt-plus-noti">
                {{
                  // !wsClipCnt['isWsMember'] ? $t('joinTheWorkspaceToRecordLongerVideo') : $t('needToRecordVideoLonger')
                  $t('joinTheWorkspaceToRecordLongerVideo')
                }}
              </span>
            </v-col>
            <v-spacer />
            <v-col :align="$vuetify.breakpoint.width < 600 ? 'center' : 'end'">
              <v-btn dark elevation="0" class="btn-plus-noti" color="rgb(40, 144, 103)" @click="plusNoti">
                {{ !wsClipCnt['isWsMember'] ? $t('sendRequest') : $t('learnMore') }}
              </v-btn>
            </v-col>
          </v-row>
          <!-- Floating 영역 -->
          <v-row
            ref="previewContainer"
            align="center"
            justify="center"
            :align-content="floatingState === State.Text ? 'start' : 'center'"
            align-self="center"
            no-gutters
            :class="
              floatingState !== State.Preview
                ? floatingState === State.Normal
                  ? ''
                  : floatingState === State.Embed || floatingState === State.Poll
                  ? 'floating-layout-active floating-layout-non-screen'
                  : 'floating-layout-active'
                : 'floating-layout-active-hide'
            "
          >
            <!-- Floating Normal UI -->
            <!-- v-if="floatingState === State.Normal" -->
            <v-row
              align-content="center"
              class="d-flex flex-nowrap floating-menu"
              v-if="false"
              align="center"
              justify="center"
            >
              <v-col class="pa-0 pl-2 pb-1" cols="auto">
                <v-icon class="fs-40" color="white" @click="$store.dispatch('beforeClip')">mdi-skip-previous</v-icon>
                <v-icon ref="play_icon" class="fs-40" color="white" @click="pauseAndResume()">
                  {{ isPauseIcon ? 'mdi-pause' : 'mdi-play' }}
                </v-icon>
                <v-icon class="fs-40" color="white" @click="$store.dispatch('nextClip')">mdi-skip-next</v-icon>
              </v-col>
              <v-spacer />
              <v-col style="text-align: center; padding-top: 10px" cols="auto" align-self="center">
                <v-avatar
                  style="width: 46px !important; height: 46px !important"
                  color="#ffffff"
                  class="logo pr-5"
                  round
                  size="45"
                  @click="recordSetting()"
                >
                  <v-icon style="font-size: 50px; margin-left: 20px" color="#ff575f">mdi-record</v-icon>
                </v-avatar>
              </v-col>
              <v-spacer />
              <v-col class="pt-2" style="text-align: end" cols="auto">
                <v-spacer style="width: 90px"></v-spacer>
              </v-col>
            </v-row>

            <!-- 녹화 영역 -->
            <div
              v-if="
                floatingState === State.RecordSetting ||
                floatingState === State.CountDown ||
                floatingState === State.Recording
              "
              :class="isIncludeScreen ? 'record-layout' : 'record-layout-notScreen'"
            >
              <audio-recorder
                v-if="getRecordType() === 'audio'"
                ref="audioRecorder"
                :form.sync="form"
                :isMuted.sync="isMuted"
                @readyToStart="isReadyToStart = $event"
                @disableRecorder="disableRecorder('audio')"
                @saveBlob="saveBlob($event)"
                @startAnalyser="setStream($event)"
                @stopAnalyser="stopAnalyser()"
              ></audio-recorder>
              <media-recorder
                v-else-if="getRecordType() === 'face'"
                ref="mediaRecorder"
                :form.sync="form"
                :isMuted.sync="isMuted"
                :isMicGranted.sync="isMicGranted"
                @readyToStart="isReadyToStart = $event"
                @disableRecorder="disableRecorder('face')"
                @saveBlob="saveBlob($event)"
                @startAnalyser="setStream($event)"
                @stopAnalyser="stopAnalyser()"
              ></media-recorder>
              <screen-and-media-recorder
                v-else-if="getRecordType() === 'screen'"
                ref="screenAndMediaRecorder"
                :form.sync="form"
                :isMuted.sync="isMuted"
                :isShowFace.sync="isIncludeFace"
                :isMicGranted.sync="isMicGranted"
                :isCameraGranted.sync="isCameraGranted"
                :floatingState.sync="floatingState"
                :containerSize.sync="containerSize"
                @readyToStart="isReadyToStart = $event"
                @disableRecorder="disableRecorder($event)"
                @saveBlob="saveBlob($event)"
                @stopSharing="stopSharing($event)"
                @finishRecordTrick="finishRecordTrick()"
                @startAnalyser="setStream($event)"
                @stopAnalyser="stopAnalyser()"
              ></screen-and-media-recorder>
              <!-- 선택된 옵션이 없는 경우 -->
              <v-row class="all-off-layout" justify="center" align="center" v-else no-gutters>
                <v-col cols="12" align="center" class="all-off-title">Recording preview will show up here 🎥</v-col>
                <v-col cols="12" align="center" class="all-off-desc mt-2">
                  Select one of the options below to begin
                </v-col>
              </v-row>
            </div>

            <div v-else-if="floatingState === State.Upload" class="record-layout">
              <upload-video @closeUploadVideo="closeUploadVideo" @saveBlob="saveBlob($event)"></upload-video>
            </div>

            <!-- Preview 영역 -->
            <div v-else-if="floatingState === State.Preview" class="record-layout-preview">
              <record-preview
                v-show="floatingState === State.Preview"
                :recordType="getRecordType()"
                :blob.sync="blob"
                :duration.sync="duration"
                @captureThumbnail="thumbnail = $event"
                ref="refPreview"
              ></record-preview>
            </div>

            <div
              v-else-if="floatingState === State.Embed"
              class="record-layout embed-layout"
              style="aspect-ratio: unset"
            >
              <embed-dialog
                v-show="floatingState === State.Embed"
                :blob.sync="blob"
                @contentData="setContentData"
                @valid="setValid"
                ref="embedDialog"
              ></embed-dialog>
            </div>

            <div v-else-if="floatingState === State.Poll" class="record-layout">
              <poll-dialog
                v-show="floatingState === State.Poll"
                :blob.sync="blob"
                @contentData="setContentData"
              ></poll-dialog>
            </div>

            <div v-else-if="floatingState === State.Text" class="non-record-layout">
              <texteditor-dialog
                v-show="floatingState === State.Text"
                :blob.sync="blob"
                @textClip="setTextClip"
              ></texteditor-dialog>
            </div>
          </v-row>

          <!-- 타이머 영역 -->
          <!-- <div class="floating-all-layout" style="z-index: 204"> -->
          <div class="floating-all-layout" v-if="floatingState === State.CountDown" style="z-index: 204">
            <div class="countdown-layout">
              <v-row align="center" justify="center" style="align-content: center">
                <v-col cols="12" align="center">
                  <span v-if="countDownTimer !== undefined && countDownTimer !== null">
                    <h1>{{ timeLeft }}</h1>
                  </span>
                  <span v-else class="txt-preparing px-5 pb-10">Preparing ...</span>
                </v-col>

                <v-col cols="12" align="center">
                  <v-btn
                    width="100"
                    dark
                    color="#ff575f"
                    @click="skipCountDown()"
                    :disabled="countDownTimer === undefined || countDownTimer === null"
                    :loading="countDownTimer === undefined || countDownTimer === null"
                  >
                    Skip
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </div>
          <media-device-list
            :isShowDeviceDialog.sync="isShowDeviceDialog"
            :isDeviceListGranted.sync="isDeviceListGranted"
            @callBack="saveDeviceId($event)"
          ></media-device-list>
          <el-dialog
            title="Access Required"
            :visible.sync="isPermissionDialog"
            class="access-dialog"
            width="490px"
            center
            :modal-append-to-body="false"
          >
            <span>{{ $t('browserAccessPermission') }}</span>
            <span slot="footer" class="dialog-footer">
              <el-button
                style="width: 100%; background: #27cd8b; font-weight: bold; color: white; border: 0"
                @click="isPermissionDialog = false"
              >
                Close
              </el-button>
            </span>
          </el-dialog>
          <audio-not-available-dialog
            v-if="isAudioNotAvailableDialog"
            :isAudioNotAvailableDialog="isAudioNotAvailableDialog"
            @close="closeAudioDisabled"
            @done="continueAudioDisabled"
          ></audio-not-available-dialog>
          <setting-dialog
            v-if="settingVisible"
            :settingVisible.sync="settingVisible"
            :menuType="'PLANBILLING'"
            @openManage="openDialog"
            @openSlot="openDialog"
            @close="closeDialog"
          ></setting-dialog>
        </div>
        <div
          v-if="
            floatingState === State.Preview ||
            floatingState === State.RecordSetting ||
            floatingState === State.CountDown ||
            floatingState === State.Recording
          "
          class="warp-script-layout"
        >
          <div
            v-if="
              floatingState !== State.Preview &&
              (floatingState === State.RecordSetting ||
                floatingState === State.CountDown ||
                floatingState === State.Recording)
            "
            style="height: calc(100% - 50px)"
          >
            <v-tabs
              v-model="tab"
              class="mt-3"
              style="margin-bottom: 10px"
              background-color="transparent"
              color="white"
              grow
              dark
              height="30"
              hide-slider
            >
              <v-tab key="script" :disabled="floatingState === State.Recording">
                <span class="material-icons-round mr-2" style="font-size: 17px" translate="no">description</span>
                {{ 'Script' }}
              </v-tab>
              <v-tab v-if="floatingState === State.RecordSetting" key="layout" :disabled="isFaceAndScreen()">
                <span class="material-icons-round mr-2" style="font-size: 17px" translate="no">space_dashboard</span>
                {{ 'Layout' }}
              </v-tab>
            </v-tabs>

            <v-tabs-items
              v-model="tab"
              style="overflow: auto; height: 100%; border: 1px solid transparent; border-radius: 5px"
            >
              <v-tab-item key="script" :eager="true" style="height: 100%">
                <v-card flat class="bgcolor-transparent" style="height: 100%">
                  <record-script
                    v-if="
                      floatingState === State.RecordSetting ||
                      floatingState === State.CountDown ||
                      floatingState === State.Recording
                    "
                  ></record-script>
                </v-card>
              </v-tab-item>
              <v-tab-item key="layout" :eager="true">
                <v-card flat class="bgcolor-transparent">
                  <layout-controller
                    v-if="floatingState === State.RecordSetting && isIncludeScreen"
                    class="layoutController"
                  ></layout-controller>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </div>
          <div v-else style="margin-top: 50px; height: calc(100% - 53px)">
            <record-preview-option
              v-show="floatingState === State.Preview"
              :recordType="getRecordType()"
              :blob.sync="blob"
              :duration.sync="duration"
              :textClip.sync="textClip"
              :isClipUploadLoading.sync="isClipUploadLoading"
              :isMtCreateLoading.sync="isMtCreateLoading"
              @openMultipartUpload="openMultipartUpload"
              @discardUpload="discardUpload"
              @captureThumbnail="thumbnail = $event"
              @clipNote="clipNote = $event"
              @textClip="textClip = $event"
              @clipTitle="clipTitle = $event"
              @language="sttLanguage = $event"
              @submitTopic="summaryTopics = $event"
              @submitTemplate="summaryTemplate = $event"
              ref="refPreview"
            ></record-preview-option>
          </div>
        </div>
      </div>

      <v-row
        v-if="floatingState === State.Text || floatingState === State.Embed"
        align="center"
        justify="center"
        style="padding: 0 24px"
      >
        <v-col style="padding-bottom: 0">
          <v-text-field
            label="Enter title (optional)"
            :placeholder="$t('enterTitle')"
            v-model="clipTitle"
            dark
            solo
            background-color="#161d21"
            hide-details
            class="line-border"
          ></v-text-field>
        </v-col>
      </v-row>

      <div
        :style="
          floatingState === State.RecordSetting ||
          floatingState === State.CountDown ||
          floatingState === State.Recording
            ? 'display: flex; align-content: center; justify-content: center; margin-top: 30px'
            : 'display: flex; align-content: center; justify-content: center; margin-top: 15px'
        "
      >
        <!-- 녹화방법 UI -->
        <v-row
          dense
          no-gutters
          v-if="floatingState === State.RecordSetting"
          class="floating-method-record"
          align="center"
        >
          <v-col cols="auto" class="wrap-btn-record pl-5 mr-2" align="center" style="display: inline-flex">
            <v-btn height="50" plain @click="changeRecordType('audio')">
              <audio-recorder-btn v-if="isIncludeAudio" :audioStream.sync="micStream"></audio-recorder-btn>
              <span v-else class="material-icons-round fs-30 fw-400 color-gray" translate="no">
                {{ 'mic_off' }}
              </span>
              <span class="btn-text mt-1">{{ isIncludeAudio ? 'Mute' : 'Unmute' }}</span>
            </v-btn>
            <v-btn height="50" plain @click="changeRecordType('face')">
              <span class="material-icons-round fs-30 fw-400 color-gray" translate="no">
                {{ isIncludeFace ? 'videocam' : 'videocam_off' }}
              </span>
              <span class="btn-text mt-1">{{ 'Camera' }}</span>
            </v-btn>
            <div
              class="floating-menu"
              v-if="floatingState === State.RecordSetting || floatingState === State.CountDown"
            >
              <v-btn
                v-if="floatingState === State.CountDown"
                plain
                height="50"
                class="start-meeting-inActive"
                @click="countDownCancel()"
              >
                {{ $t('deleteCancel') }}
              </v-btn>
              <v-tooltip v-else bottom color="#131b1e">
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    height="50"
                    plain
                    :class="getRecordType() === null ? 'start-meeting-inActive' : 'start-meeting-active'"
                    :disabled="!isReadyToStart"
                    @click="checkAudioDisabled()"
                    elevation="0"
                  >
                    <div class="btn-record-outer">
                      <div class="btn-record-inner"></div>
                    </div>
                  </v-btn>
                </template>
                <span>{{ 'Start Recording' }}</span>
              </v-tooltip>
            </div>

            <v-btn height="50" plain @click="changeRecordType('screen')">
              <span class="material-icons-round fs-30 fw-400 color-gray" translate="no">
                {{ isIncludeScreen ? 'desktop_windows' : 'desktop_access_disabled' }}
              </span>
              <span class="btn-text mt-1">{{ 'Screen' }}</span>
            </v-btn>
            <v-btn height="50" plain @click="checkDeviceList">
              <span class="material-icons-round fs-30 fw-400 color-gray" translate="no">more_horiz</span>
              <span class="btn-text mt-1">{{ 'More' }}</span>
            </v-btn>
          </v-col>
        </v-row>

        <!-- Floating Recording UI -->
        <v-row
          dense
          no-gutters
          align="center"
          class="floating-menu wrap-btn-recording"
          v-show="floatingState === State.Recording"
        >
          <v-col class="mx-5" cols="auto">
            <v-btn height="50" plain @click="changeRecordType('audio')">
              <audio-recorder-btn v-if="!isMuted" :audioStream.sync="micStream"></audio-recorder-btn>
              <span v-else class="material-icons-round fs-30 fw-400 color-gray" translate="no">
                {{ 'mic_off' }}
              </span>
              <span class="btn-text mt-1">{{ isMuted ? 'Unmute' : 'Mute' }}</span>
            </v-btn>
          </v-col>
          <v-spacer />
          <v-col class="mx-2" cols="auto">
            <v-btn height="50" plain @click="discardRecording()">
              <span class="material-icons-round fs-30 fw-400 color-gray" translate="no">delete_forever</span>
              <span class="btn-text mt-1">{{ 'Cancel' }}</span>
            </v-btn>
          </v-col>
          <v-col class="mx-10" cols="auto">
            <v-tooltip bottom color="#131b1e">
              <template v-slot:activator="{ on }">
                <v-btn height="50" plain v-on="on" @click="completeRecord" elevation="0">
                  <div class="btn-record-complete-outer">
                    <div class="btn-record-complete-inner"></div>
                  </div>
                </v-btn>
              </template>
              <span>{{ 'Finish Recording' }}</span>
            </v-tooltip>
          </v-col>
          <v-col class="mx-2" cols="auto">
            <v-btn height="50" plain @click="restart()">
              <span class="material-icons-round fs-30 fw-400 color-gray" translate="no">restart_alt</span>
              <span class="btn-text mt-1">{{ 'Restart' }}</span>
            </v-btn>
          </v-col>
          <v-col class="ml-8" cols="auto" v-show="floatingState === State.Recording">
            <timer :isRecordPause.sync="isRecordPause" @completeRecord="completeRecord" ref="timer"></timer>
          </v-col>
          <v-spacer />
        </v-row>

        <v-row
          v-if="
            !(
              floatingState === State.RecordSetting ||
              floatingState === State.CountDown ||
              floatingState === State.Recording
            )
          "
          class="floating-method mx-8 mb-5"
          style="justify-content: center"
          align="center"
        >
          <v-col cols="auto" class="wrap-btn-preview" align="start" style="position: absolute; left: 0">
            <notification-dialog
              v-if="mtInfo && userInfo"
              @customRecipientList="setCustomRecipientList"
              @chkboxWs="setChkboxWs"
              @chkboxPostComment="setChkboxPostComment"
            ></notification-dialog>
          </v-col>
          <v-col cols="12" class="wrap-btn-preview" align="center" style="">
            <v-btn
              height="50"
              plain
              @click="discardUpload"
              :class="floatingState === State.Preview ? '' : ''"
              :disabled="isClipUploadLoading || isMtCreateLoading"
            >
              <span class="material-icons-round fs-30 fw-400 color-gray" translate="no">close</span>
              <span class="btn-text mt-1">{{ $t('discard') }}</span>
            </v-btn>
            <v-btn
              v-if="
                floatingState === State.Preview ||
                floatingState === State.Text ||
                floatingState === State.Embed ||
                floatingState === State.Poll
              "
              height="50"
              plain
              :disabled="disablePostBtn(floatingState)"
              :loading="isClipUploadLoading || isMtCreateLoading"
              @click="post"
              class="ml-10"
            >
              <span class="material-icons-round fs-30 fw-400 color-green" translate="no">done</span>
              <span class="btn-text mt-1 color-green">{{ $t('post') }}</span>
            </v-btn>
          </v-col>
          <!-- <v-col
            v-if="$vuetify.breakpoint.width >= 600"
            cols="auto"
            class="wrap-btn-preview wrap-btn-noti"
            align="center"
          >
            <notification-dialog
              v-if="mtInfo && userInfo"
              @customRecipientList="setCustomRecipientList"
              @chkboxWs="setChkboxWs"
              @chkboxPostComment="setChkboxPostComment"
            ></notification-dialog>
          </v-col> -->
        </v-row>
      </div>
    </div>
  </v-container>
</template>

<script>
// import AudioAnalyser from '@/views/meeting/component/record/AudioAnalyser'
import MediaRecorder from '@/views/meeting/component/record/MediaRecorder'
import AudioRecorder from '@/views/meeting/component/record/AudioRecorder.vue'
import AudioRecorderBtn from '@/views/meeting/component/record/AudioRecorderBtn.vue'
import ScreenAndMediaRecorder from '@/views/meeting/component/record/ScreenAndMediaRecorder'
import MediaDeviceList from '@/views/meeting/component/record/MediaDeviceList.vue'
import Timer from '@/views/meeting/component/record/Timer.vue'
import RecordPreview from '@/views/meeting/component/record/RecordPreview.vue'
import RecordPreviewOption from '@/views/meeting/component/record/RecordPreviewOption.vue'
// import DeleteFollowUpDialog from '@/views/modal/DeleteFollowUpDialog'
import UploadVideo from '@/views/meeting/component/record/UploadVideo'
import { mapGetters } from 'vuex'
import { isChrome, isMobile } from '@/common/lib/strLib'
// import UploadProgress from '@/views/meeting/component/record/UploadProgress'
// import SelectSectionDialog from '@/views/modal/SelectSectionDialog'
import { getWsUsedStorage } from '@/services/api'
import LayoutController from '@/views/meeting/component/record/LayoutController'
import RecordScript from '@/views/meeting/component/record/RecordScript'
import EmbedDialog from '@/views/modal/EmbedDialog'
import PollDialog from '@/views/modal/PollDialog'
import TexteditorDialog from '@/views/modal/TexteditorDialog'
import AudioNotAvailableDialog from '@/views/modal/AudioNotAvailableDialog'
import SettingDialog from '@/views/modal/SettingDialog'
import { setRequestJoinWs } from '@/services/api'
import NotificationDialog from '@/views/modal/NotificationDialog'
import Toast from '@/views/meeting/component/Toast'

const State = Object.freeze({
  Normal: 'normal',
  RecordSetting: 'recordSetting',
  Recording: 'recording',
  CountDown: 'countDown',
  Preview: 'preview',
  Upload: 'upload',
  Embed: 'embed',
  Poll: 'poll',
})
const MIN_DURATION = 30 // 자막 생성 위한 최소 클립 시간 (초)

export default {
  components: {
    // AudioAnalyser,
    MediaRecorder,
    AudioRecorder,
    AudioRecorderBtn,
    ScreenAndMediaRecorder,
    MediaDeviceList,
    Timer,
    RecordPreview,
    RecordPreviewOption,
    // UploadProgress,
    // DeleteFollowUpDialog,
    UploadVideo,
    // SelectSectionDialog,
    LayoutController,
    RecordScript,
    EmbedDialog,
    PollDialog,
    TexteditorDialog,
    AudioNotAvailableDialog,
    SettingDialog,
    NotificationDialog,
  },
  data() {
    return {
      isExtensionClipUploadFinished: false,

      path: '',
      // 녹화 관련
      State,
      floatingState: State.Normal,
      isMuted: !this.isIncludeAudio,
      isShowDeviceDialog: false,
      recordType: [],
      blob: null,
      // STT 를 위한 Blob Array
      audioBlobs: null,
      audioSilenceList: null,
      duration: null,
      thumbnail: null,
      clipNote: null,
      textClip: null,
      contentData: null,
      clipTitle: null,
      customRecipientList: null,
      chkboxWs: this.mtInfo && this.mtInfo.mtPermission == 'private' ? false : true,
      chkboxPostComment: true,
      sectionTitle: null,
      // deleteFollowUpVisible: false,
      isPermissionDialog: false,
      form: {
        audioId: '',
        videoId: '',
      },
      isDeviceListGranted: false,
      // isShareDialog: false,
      timeLeft: 3,
      countDownTimer: null,
      isMicGranted: null,
      isCameraGranted: null,
      menuData: {
        menuIcon: 'mdi-dots-horizontal',
        iconColor: '#ffffff',
        bgColor: '#21343b',
        iconClass: 'ml-5',
        textClass: 'white--text ma-1',
        items: [
          { title: 'Text Message', type: 'text' },
          { title: 'Upload Video', type: 'upload' },
        ],
      },
      // 임시로 업로드 된 Clip Id
      tempClipId: '',
      // isShowProgressDialog: '',
      audio: new Audio(require('@/assets/audio/recording_start.mp3')),
      // mp4 Upload 여부 확인
      isUploadClip: false,
      isRecordPause: false,
      isReadyToStart: false,

      // Stt 를 보내기 위한 음성값이 없을 경우
      noSttAudioDetectTimeOut: null,

      // 오디오 사용 불가 여부
      isAudioDisabled: false,
      isAudioNotAvailableDialog: false,
      micStream: null,
      mediaStream: null,
      audioCheckResult: null,
      audioCheckInterval: null,
      noAudioDetectTimeOut: null,
      isClipUploadLoading: false,
      isMtCreateLoading: false,
      settingVisible: false,
      isRequestJoinWsLoading: false,
      // Chrome 111 version 버그로 인해 preparing 이 계속 되면 preview 를 종료시켜주는 timer 를 추가
      preparingTimeout: null,
      tab: null,
      videoHeight: null,
      valid: true,
      // Detail.vue 에서 미팅정보 로드가 끝났는지 확인이 어려워서 주기적으로 체크하는 Interval 을 만들어놨음..
      chkFinishMtLoadingInterval: null,

      containerSize: 0,
      sttLanguage: null,

      summaryTopics: null,
      summaryTemplate: null,
    }
  },
  computed: {
    ...mapGetters([
      'isReplaceFollowUp',
      'userInfo',
      'currentMt',
      'totalSectionList',
      'sectionIndex',
      'isRequestVideoType',
      'requestSaveBlob',
      'selectedWsInfo',
      'selectedCh',
      'wsClipCnt',
    ]),
    mtInfo() {
      return this.$store.getters.currentMt
    },
    mtId() {
      return this.$route.params.mtId ?? this.currentMt['mtId']
    },
    wsId() {
      let wsId = ''
      if (this.selectedCh && this.selectedCh['wsId'] && this.selectedCh['wsId'] !== '') wsId = this.selectedCh['wsId']
      else if (this.selectedWsInfo && this.selectedWsInfo['wsId'] && this.selectedWsInfo['wsId'] !== '')
        wsId = this.selectedWsInfo['wsId']
      else if (this.currentMt && this.currentMt['wsId'] && this.currentMt['wsId'] !== '') wsId = this.currentMt['wsId']
      return wsId
    },
    isMobile() {
      return isMobile()
    },
    isAvailableMic() {
      return (
        this.audioCheckResult !== undefined &&
        this.audioCheckResult !== null &&
        this.audioCheckResult.state !== 'denied' &&
        this.audioCheckResult.state !== 'prompt'
      )
    },
    stId() {
      let stId = ''
      if (this.currentMt && this.currentMt.sectionInfo && this.currentMt.sectionInfo.length > 0)
        stId = this.currentMt.sectionInfo[this.sectionIndex].stId

      return stId
    },
    isIncludeAudio() {
      return this.recordType.includes('audio')
    },
    isIncludeScreen() {
      return this.recordType.includes('screen')
    },
    isIncludeFace() {
      return this.recordType.includes('face')
    },
    isPlayerPause() {
      return this.$store.getters.isPlayerPause !== undefined && this.$store.getters.isPlayerPause !== null
        ? this.$store.getters.isPlayerPause
        : false
    },
    isPauseIcon() {
      return this.$store.getters.isPauseIcon !== undefined && this.$store.getters.isPauseIcon !== null
        ? this.$store.getters.isPauseIcon
        : false
    },
    currentClip() {
      let currentClip = this.$store.getters.currentClip
      return currentClip !== undefined && currentClip !== null ? currentClip : {}
    },
  },
  mounted() {
    // Chrome extension 에서 녹화해서 넘긴 blob 이 있는지 검사한다.
    this.chkFinishMtLoadingInterval = setInterval(() => {
      if (this.currentMt) {
        clearInterval(this.chkFinishMtLoadingInterval)
        this.chkFinishMtLoadingInterval = null
        this.checkChromeExtensionClipInfo()
      }
    }, 100)
    // this.checkChromeExtensionClipInfo()

    // Container 변화값 감지를 위한 event
    window.addEventListener('resize', this.resize)
  },
  methods: {
    setStream(val) {
      if (val) {
        this.micStream = val['micStream']
        this.mediaStream = val['micAndMediaStream']
        this.startAnalyser()
      }
    },
    resize() {
      this.containerSize = this.$refs.previewContainer ? this.$refs.previewContainer.offsetWidth : 0
    },
    // Extension 에서 업로드한 클립이 있는지 여부 체크
    async checkChromeExtensionClipInfo() {
      let data
      // let ctx = this
      try {
        let parsedClipInfo = localStorage.getItem('extensionClipInfo')
        // console.log('parsedClipInfo ', parsedClipInfo)

        if (parsedClipInfo && parsedClipInfo !== '') {
          // this.$store.dispatch('setIsExtensionClipUploadFinish', false)

          data = JSON.parse(parsedClipInfo)

          if (data && data['selectedChannel']) {
            this.$store.dispatch('setSelectedCh', data['selectedChannel'])
          }

          // this.wsId = data['wsId']
          this.thumbnail = data['thumbnail']
          // this.clipType = data['clipType']
          this.recordType = [data['clipType']]
          this.duration = data['clipDuration']
          this.clipTitle = data['clipTitle']
          this.audioSilenceList = data['audioSilenceList']

          // Video Blob Parsing
          try {
            let response = await fetch(data['blobUrl'])
            let videoBlob = await response.blob()
            this.blob = videoBlob
          } catch (error) {
            console.log('clip data error : ', error)
            localStorage.removeItem('extensionClipInfo')
          }

          try {
            let audioBlobUrls = data['audioBlobUrls']
            if (audioBlobUrls && Array.isArray(audioBlobUrls)) {
              let tempAudioBlobs = []
              for (let index in audioBlobUrls) {
                // STT 를 위한 audio blob 읽기 및 저장
                let audioResponse = await fetch(audioBlobUrls[index])
                let audioBlob = await audioResponse.blob()

                tempAudioBlobs.push(audioBlob)
              }

              this.audioBlobs = tempAudioBlobs
            }
          } catch (error) {
            console.log('audio data error : ', error)
          } finally {
            // audio Blob 이 이상하게 들어온 경우 그냥 진행시킨다.
            // ctx.setCreateClip()
            // ctx.completeRecord()
            this.floatingState = State.Preview

            //익스텐션 클립 업로드 끝나는 시점
            localStorage.removeItem('extensionClipInfo')
          }

          // fetch(data['blobUrl'])
          //   .then((res) => res.blob())
          //   .then((blob) => {
          //     this.blob = blob

          //     // let audioBlobUrls = data['audioBlobUrls']
          //     // if (audioBlobUrls && Array.isArray(audioBlobUrls)) {
          //     //   let tempAudioBlobs = []
          //     //   for (let audioBlobUrl of audioBlobUrls) {
          //     //     console.log('시작? ')
          //     //     let response = await fetch(audioBlobUrl)
          //     //     console.log(' 끝? ', response)
          //     //     const tempBlob = response.blob()
          //     //     tempAudioBlobs.push(tempBlob)
          //     //   }
          //     //   this.audioBlobs = tempAudioBlobs
          //     //   console.log('tempAudioBlobs !! ', tempAudioBlobs)
          //     // }
          //     // this.isShowProgressDialog = true
          //     // this.$emit('openMultipartUpload', this.clipType)
          //   })
          //   .catch((err) => {
          //     console.log('clip data error : ', err)
          //     localStorage.removeItem('extensionClipInfo')
          //   })

          // let audioBlobUrls = data['audioBlobUrls']
          // if (audioBlobUrls && Array.isArray(audioBlobUrls)) {
          //   let tempAudioBlobs = []
          //   for (let index in audioBlobUrls) {
          //     // STT 를 위한 audio blob 읽기 및 저장
          //     fetch(audioBlobUrls[index])
          //       .then((res) => res.blob())
          //       .then((blob) => {
          //         tempAudioBlobs.push(blob)

          //         if (tempAudioBlobs.length === audioBlobUrls.length) {
          //           this.audioBlobs = tempAudioBlobs
          //           ctx.setCreateClip()

          //           //익스텐션 클립 업로드 끝나는 시점
          //           localStorage.removeItem('extensionClipInfo')
          //         }
          //       })
          //   }
          // }
          // // audio Blob 이 이상하게 들어온 경우 그냥 진행시킨다.
          // else {
          //   ctx.setCreateClip()

          //   //익스텐션 클립 업로드 끝나는 시점
          //   localStorage.removeItem('extensionClipInfo')
          // }
        }
      } catch (error) {
        console.log('get localstorage error ', error)
      } finally {
        // this.$store.dispatch('setIsLoading', false)
        // this.$store.dispatch('setIsExtensionClipUploadFinish', true)
        // this.isExtensionClipUploadFinished = true
      }
    },
    isFaceAndScreen() {
      let isFaceAndScreen = false
      isFaceAndScreen = !this.isIncludeFace || !this.isIncludeScreen ? true : false
      if (isFaceAndScreen) this.tab = 0
      return isFaceAndScreen
    },
    setValid(val) {
      this.valid = val
    },
    setContentData(val) {
      this.contentData = val
    },
    setTextClip(val) {
      this.textClip = val
    },
    setCustomRecipientList(val) {
      this.customRecipientList = val
    },
    setChkboxPostComment(val) {
      this.chkboxPostComment = val
      // console.log('setChkboxPostComment', this.chkboxPostComment)
    },
    setChkboxWs(val) {
      this.chkboxWs = val
    },
    disablePostBtn(state) {
      let disabled = false
      if (state === this.State.Preview) {
        disabled = this.blob === null || this.duration === null ? true : false
      } else if (state === this.State.Text) {
        disabled = this.textClip === null || this.textClip === '' || this.textClip === '<p></p>' ? true : false
      } else if (state === this.State.Embed) {
        disabled = this.contentData === null || this.contentData === '' || !this.valid ? true : false
      } else if (state === this.State.Poll) {
        disabled =
          !this.contentData ||
          (this.contentData && !this.contentData.pollQuestion) ||
          (this.contentData && this.contentData.pollQuestion === '')
            ? true
            : false
      }
      return disabled
    },
    post() {
      if (this.floatingState === State.Text) {
        this.setCreateClip()
      } else if (this.floatingState === State.Embed) {
        if (this.contentData.url.indexOf('calendly.com') > -1) {
          this.contentData.type = 'calendar'
        } else {
          this.contentData.type = 'default'
        }
        this.templateUpload(this.contentData)
      } else if (this.floatingState === State.Embed) {
        this.templateUpload(this.contentData)
      } else if (this.floatingState === State.Poll) {
        const tempList = []

        for (let pollChoice of this.contentData.pollChoices) {
          const title = pollChoice.title
          if (title && title !== '') tempList.push(pollChoice)
        }

        this.contentData.pollChoices = tempList

        this.templateUpload(this.contentData)
      } else {
        this.$root.$refs.previewOption.postClip()
      }
    },
    async plusNoti() {
      if (!this.wsClipCnt['isWsMember']) {
        this.isRequestJoinWsLoading = true

        try {
          await setRequestJoinWs(
            this,
            this.currentMt['wsId'],
            this.userInfo['userDisplayName'] || this.userInfo['userFullName']
          )
          // notify(this, 'Success', this.$t('joinWorkspaceCompleteDesc'), 'success')

          const content = {
            component: Toast,
            props: {
              msg: this.$t('joinWorkspaceCompleteDesc'),
              // submsg: '',
            },
          }
          this.$toast.success(content)
        } catch (error) {
          // notify(this, 'Error', this.$t('general.error'), 'error')

          const content = {
            component: Toast,
            props: {
              msg: this.$t('general.error'),
              // submsg: '',
            },
          }
          this.$toast.success(content)
        } finally {
          this.isRequestJoinWsLoading = false
        }
      } else {
        this.discardPreview()
        this.settingVisible = true
      }
    },
    openDialog(type) {
      if (type === 'Setting') {
        this.settingVisible = true
      }
    },
    closeDialog(type) {
      if (type === 'Setting') {
        this.settingVisible = false
      }
    },
    closeAudioDisabled() {
      this.isAudioNotAvailableDialog = false
    },
    continueAudioDisabled() {
      this.isAudioNotAvailableDialog = false
      this.countDown()
    },
    async getStorageSize() {
      let isAvailableRecord = false
      if (this.currentMt !== undefined && this.currentMt !== null) {
        let result = await getWsUsedStorage(this, this.currentMt.wsId)
        if (result !== undefined && result !== null && result.wsUsedStorage !== undefined) {
          let gbValue = (result.wsUsedStorage / (1024 * 1024 * 1024)).toFixed(2)
          isAvailableRecord = Number(gbValue) < 50
        }
      }
      return isAvailableRecord
    },
    pauseAndResume() {
      this.$store.dispatch('setIsPlayerPause', !this.isPlayerPause)
      if (this.$refs.play_icon !== undefined && this.$refs.play_icon !== null) this.$refs.play_icon.$el.blur()
    },
    async openMultipartUpload(quickRecordParams) {
      this.$refs.refPreview.stopPreview()
      this.setCreateClip(quickRecordParams)
    },
    async templateUpload(contentData) {
      this.contentData = contentData
      this.setCreateClip()
    },
    /**
     * Upload Progress 에서 clip 생성하던 작업을 이쪽으로 옮김
     * 2023-01-18 jsyoon
     */
    async setCreateClip(quickRecordParams) {
      try {
        this.isClipUploadLoading = true

        // // Noti Type 을 선택하지 않았을 경우 default 로 세팅 해준다.
        // if (this.currentMt && !this.chkboxWs && !this.chkboxPostComment) {
        //   // Private 인 경우 clip, comment 올린 사용자에게만 전송
        //   if (this.currentMt['mtPermission'] === 'private') {
        //     this.chkboxWs = false
        //     this.chkboxPostComment = true
        //   }
        //   // workspace 인 경우 clip, comment, wsMember 에게 전송
        //   else if (this.currentMt['mtPermission'] === 'workspace') {
        //     this.chkboxWs = true
        //     this.chkboxPostComment = true
        //   }
        // }

        let notiWorkspace = this.chkboxWs ? 'workspace' : null
        let notiAttendee = this.chkboxPostComment ? 'attendee' : null
        let sendType

        if (notiWorkspace && notiAttendee) {
          sendType = [notiWorkspace, notiAttendee]
        } else if (notiWorkspace) {
          sendType = [notiWorkspace]
        } else if (notiAttendee) {
          sendType = [notiAttendee]
        } else {
          sendType = []
        }

        let emailNotiInfo = {
          customRecipientList: this.customRecipientList,
          sendType: sendType,
        }

        // 10초로 적용, Audio Blob 을 날려주고 상태값을 실패로 적용
        let transcriptStatus = 0
        let summaryStatus = 0

        // Transcript, Summary 작동 여부 세팅
        try {
          // duration 이 MIN_DURATION 보다 길고, audioBlob 이 있는 경우에 진행
          // 0 : 변환중, 1: 성공, 2: 실패, 3: 사용자 미선택 또는 짧아서 나오지 않은 경우
          if (
            this.duration &&
            this.duration > MIN_DURATION &&
            this.audioBlobs &&
            Array.isArray(this.audioBlobs) &&
            this.audioBlobs.length > 0
          ) {
            const generateOptions = localStorage.getItem('generateOptions')
            const parsedGenerateOptions =
              typeof generateOptions === 'string' ? JSON.parse(generateOptions) : ['summary', 'transcript']

            transcriptStatus = parsedGenerateOptions.includes('transcript') ? 0 : 3
            summaryStatus = parsedGenerateOptions.includes('summary') ? 0 : 3
          } else {
            transcriptStatus = 3
            summaryStatus = 3
          }
        } catch (error) {
          console.log()
        }

        // 자막을 off 해서 보냈거나 duration 이 MIN_DURATION 미만일 경우 STT 음성파일을 업로드 하지 않는다.
        if (transcriptStatus === 3) {
          this.audioBlobs = null
          this.audioSilenceList = null
        }

        let params = {
          context: this,
          sectionTitle: this.sectionTitle,
          clipTitle: this.clipTitle,
          clipNote: this.clipNote,
          clipType: this.getRecordType(),
          textClip: this.textClip,
          contentData: this.contentData,
          blob: this.blob,
          audioBlobs: this.audioBlobs,
          audioSilenceList: this.audioSilenceList,
          thumbnail: this.thumbnail,
          duration: this.duration,
          mtId: quickRecordParams ? quickRecordParams['mtId'] : null,
          stId: quickRecordParams ? quickRecordParams['stId'] : null,
          emailNotiInfo: emailNotiInfo,
          transcriptStatus: transcriptStatus,
          summaryStatus: summaryStatus,
          sttLanguage: this.sttLanguage,
          summaryTopics: this.summaryTopics,
          summaryTemplate: this.summaryTemplate,
        }
        let createClipResult = await this.$store.dispatch('setCreateClip', params)

        // 클립 업로드 후 처리
        if (createClipResult && createClipResult['type']) {
          switch (createClipResult['type']) {
            case 'uploadFinish':
              this.uploadFinish(createClipResult['value'])
              break
            case 'thumbnailUpload':
              // todo: file uploader 실행
              this.$store.dispatch('setUploadVideoInfo', {
                clip: createClipResult['clip'],
                thumbnail: this.thumbnail,
                blob: this.blob,
                audioBlobs: this.audioBlobs,
                wsId: this.wsId,
                mtId: this.mtId,
              })
              this.uploadFinish(createClipResult['value'])
              break

            default:
              break
          }
        }

        this.isClipUploadLoading = false
      } catch (error) {
        console.log()
      } finally {
        this.$store.dispatch('setIsExtensionClipUploadFinish', true)
        this.$store.dispatch('setIsLoading', false)
        this.$store.dispatch('setIsRequestVideoType', null)
      }
    },
    cancelRecording() {
      if (this.isIncludeAudio) this.isMuted = false
      if (!this.getRecordType() || this.isRequestVideoType !== 'record' || this.isReadyToStart) {
        this.discardPreview()
      }
    },
    discardRecording() {
      if (this.isIncludeAudio) this.isMuted = false
      this.$refs.timer.stopTimer(false)
      this.blob = null
      this.audioBlobs = null
      this.audioSilenceList = null
      this.duration = null
      this.thumbnail = null
      this.clipNote = null
      this.textClip = null
      this.contentData = null
      this.clipTitle = null
      this.sectionTitle = null
      this.pauseResumeRecord(false, true)
      this.pauseResumeSttRecord(true)
      this.floatingState = State.RecordSetting

      this.$store.dispatch('setIsQuickRecord', false)
      this.$store.dispatch('setIsRequestVideoType', null)
      this.$store.dispatch('setIsReplaceFollowUp', false)
    },
    async discardUpload() {
      this.discardPreview()
    },
    discardPreview() {
      this.$refs.timer.stopTimer(false)
      this.blob = null
      this.audioBlobs = null
      this.audioSilenceList = null
      this.duration = null
      this.thumbnail = null
      this.clipNote = null
      this.textClip = null
      this.contentData = null
      this.clipTitle = null
      this.sectionTitle = null
      this.isUploadClip = false
      this.isReadyToStart = false
      this.floatingState = State.Normal

      this.$store.dispatch('setIsQuickRecord', false)
      this.$store.dispatch('setIsRequestVideoType', null)
      this.$store.dispatch('setIsReplaceFollowUp', false)
    },
    changeRecordType(recordType) {
      let isEnded =
        this.$store.getters.currentMt && this.$store.getters.currentMt['isEnded']
          ? this.$store.getters.currentMt['isEnded']
          : false
      if (recordType !== 'text' && recordType !== 'upload' && recordType !== 'embed' && recordType !== 'poll')
        if (this.isIncludeAudio && this.floatingState === State.Recording) {
          this.isMuted = !this.isMuted
        } else this.checkPermission(recordType)
      else if (recordType === 'text') {
        if (isEnded) {
          // notify(this, 'Error', this.$t('notiEndedMeeting'), 'error')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('notiEndedMeeting'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
        } else {
          this.floatingState = State.Text
        }
      } else if (recordType === 'embed') {
        if (isEnded) {
          // notify(this, 'Error', this.$t('notiEndedMeeting'), 'error')

          const content = {
            component: Toast,
            props: {
              msg: this.$t('notiEndedMeeting'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
        } else {
          this.floatingState = State.Embed
        }
      } else if (recordType === 'poll') {
        if (isEnded) {
          // notify(this, 'Error', this.$t('notiEndedMeeting'), 'error')

          const content = {
            component: Toast,
            props: {
              msg: this.$t('notiEndedMeeting'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
        } else {
          this.floatingState = State.Poll
        }
      } else if (recordType === 'upload') {
        if (isChrome() === 'Mobile') {
          // notify(this, 'Error', this.$t('notSupportedEnvMsgMobile').replace('<br />', ''), 'error')

          const content = {
            component: Toast,
            props: {
              msg: this.$t('notSupportedEnvMsgMobile').replace('<br />', ''),
              // submsg: '',
            },
          }
          this.$toast.error(content)
        } else if (isEnded) {
          // notify(this, 'Error', this.$t('notiEndedMeeting'), 'error')

          const content = {
            component: Toast,
            props: {
              msg: this.$t('notiEndedMeeting'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
        } else {
          this.isUploadClip = true
          this.floatingState = State.Upload
        }
      }
    },
    // 권한 확인
    async checkPermission(recordType) {
      let tempPermission = this.recordType.slice()
      let isAddMethod = !tempPermission.includes(recordType)

      if (tempPermission.includes(recordType)) tempPermission.splice(tempPermission.indexOf(recordType), 1)
      else if (recordType && recordType !== null) tempPermission.push(recordType)

      if (isAddMethod) {
        let audioResult = null
        let videoResult = null
        let isGranted = false
        // todo : granted 변수 작업해야함

        // 사용 가능한 마이크 여부
        let isAudioDevice = false

        // 사용 가능한 웹캠 여부
        let isVideoDevice = false

        // 카메라와 마이크 리스트
        await navigator.mediaDevices
          .enumerateDevices()
          .then(function (devices) {
            devices.forEach(function (device) {
              if (device.kind.includes('audioinput')) {
                isAudioDevice = true
              } else if (device.kind.includes('videoinput')) {
                isVideoDevice = true
              }
            })
          })
          .catch(function (err) {
            console.log(err.name + ': ' + err.message)
          })

        audioResult = await navigator.permissions.query({ name: 'microphone' })
        videoResult = await navigator.permissions.query({ name: 'camera' })

        this.audioCheckResult = audioResult
        this.isMicGranted = audioResult && audioResult.state !== 'denied' && isAudioDevice
        this.isCameraGranted = videoResult && videoResult.state !== 'denied' && isVideoDevice

        // 퍼미션 허용 체크
        if (tempPermission.includes('audio') && tempPermission.includes('face'))
          isGranted = this.isMicGranted && this.isCameraGranted
        else if (tempPermission.includes('audio')) isGranted = this.isMicGranted
        else if (tempPermission.includes('face')) isGranted = this.isCameraGranted
        else if (tempPermission.includes('screen')) isGranted = true

        if (isGranted) {
          this.isPermissionDialog = false
          this.isShowDeviceDialog = false
          this.setRecordType(recordType)
        } else {
          // 처음 세팅일 경우
          if (recordType === null) {
            // 저장된 녹화 Preference 가 있으면
            let recordPreference

            try {
              recordPreference = localStorage.getItem('recordType')
            } catch (e) {
              console.log(e)
            }

            if (recordPreference && recordPreference !== null && recordPreference.length > 0) {
              let arrayType = JSON.parse(recordPreference)
              let returnValue = []
              if (this.isMicGranted && arrayType.includes('audio')) returnValue.push('audio')
              if (this.isCameraGranted && arrayType.includes('face')) returnValue.push('face')
              if (arrayType.includes('screen')) returnValue.push('screen')
              this.recordType = returnValue
            } else {
              if (this.isMicGranted && this.isCameraGranted) this.recordType = ['audio', 'face']
              else if (this.isMicGranted) this.recordType = ['audio']
              else if (this.isCameraGranted) this.recordType = ['face']
              else this.recordType = ['screen']
            }

            this.isPermissionDialog = false
            this.isShowDeviceDialog = false
          } else {
            if (recordType === 'audio' && !isAudioDevice) {
              // notify(this, 'Error', this.$t('audioDeviceNotFoundError'), 'error')

              const content = {
                component: Toast,
                props: {
                  msg: this.$t('audioDeviceNotFoundError'),
                  // submsg: '',
                },
              }
              this.$toast.error(content)
            } else if (recordType === 'face' && !isVideoDevice) {
              // notify(this, 'Error', this.$t('videoDeviceNotFoundError'), 'error')

              const content = {
                component: Toast,
                props: {
                  msg: this.$t('videoDeviceNotFoundError'),
                  // submsg: '',
                },
              }
              this.$toast.error(content)
            } else {
              this.isPermissionDialog = true
              if (this.recordType.includes('audio') && !this.isMicGranted)
                this.recordType.splice(this.recordType.indexOf('audio'), 1)

              if (this.recordType.includes('face') && !this.isCameraGranted)
                this.recordType.splice(this.recordType.indexOf('face'), 1)
            }
          }
        }
      } else {
        this.setRecordType(recordType)
      }
    },
    // Record Type 변경
    setRecordType(val) {
      if (this.recordType.includes(val)) {
        this.recordType.splice(this.recordType.indexOf(val), 1)
        // if (val === 'audio') this.isMuted = true
      } else {
        this.recordType.push(val)
        // if (val === 'audio') this.isMuted = false
      }
    },
    disableRecorder(recordType) {
      if (this.recordType.includes(recordType)) {
        this.recordType.splice(this.recordType.indexOf(recordType), 1)
        // if (recordType === 'audio') this.isMuted = true
      }
    },
    async checkDeviceList() {
      const queryObject = {
        name: 'camera' || 'microphone',
      }
      let result = await navigator.permissions.query(queryObject)

      if (result.state === 'granted') {
        this.isShowDeviceDialog = true
        this.isDeviceListGranted = true
      } else if (result.state === 'prompt') {
        this.isShowDeviceDialog = true
        this.isDeviceListGranted = false
      } else if (result.state === 'denied') {
        this.isPermissionDialog = true
        this.isDeviceListGranted = false
      }
    },
    // 권한 해제
    async revokePermission() {
      // let result = await navigator.permissions.revoke({ name: 'camera' })
      // console.log('revoke')
      // console.log(result.state)
    },
    moveSignIn() {
      this.$route.replace({ name: 'SignIn' })
    },
    saveDeviceId(form) {
      if (form != null) {
        this.form = form
      }
      this.isShowDeviceDialog = false
    },
    recordSetting() {
      let browser = isChrome()

      let isEnded =
        this.$store.getters.currentMt && this.$store.getters.currentMt['isEnded']
          ? this.$store.getters.currentMt['isEnded']
          : false

      // TODO : 용량 제한 로직 추가
      // let isCheckStorage = this.getStorageSize()
      let isCheckStorage = true

      // 모바일 녹화 불가 메세지
      if (browser === 'Mobile') {
        // notify(this, 'Error', this.$t('notSupportedEnvMsgMobile').replace('<br />', ''), 'error')

        const content = {
          component: Toast,
          props: {
            msg: this.$t('notSupportedEnvMsgMobile').replace('<br />', ''),
            // submsg: '',
          },
        }
        this.$toast.error(content)
        this.$store.dispatch('setIsRequestVideoType', null)
      }
      // 크롬 외 브라우저 녹화 불가 메세지
      else if (browser !== 'Chrome') {
        // notify(this, 'Error', this.$t('recordingNotSupportedMsg'), 'error')

        const content = {
          component: Toast,
          props: {
            msg: this.$t('recordingNotSupportedMsg'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
        this.$store.dispatch('setIsRequestVideoType', null)
      }
      // 종료된 미팅 녹화 불가 메세지
      else if (isEnded) {
        // notify(this, 'Error', this.$t('notiEndedMeeting'), 'error')

        const content = {
          component: Toast,
          props: {
            msg: this.$t('notiEndedMeeting'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
        this.$store.dispatch('setIsRequestVideoType', null)
      }
      // Storage Size 가 50GB 가 넘어갈 경우 녹화 불가 메세지
      else if (!isCheckStorage) {
        // notify(this, 'Error', this.$t('notEnoughStorage'), 'error')

        const content = {
          component: Toast,
          props: {
            msg: this.$t('notEnoughStorage'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
        this.$store.dispatch('setIsRequestVideoType', null)
      } else {
        // notify('크롬이나 엣지에서 이용가능합니다.')
        if (this.userInfo && this.userInfo !== null) {
          // 녹화버튼 클릭 시 Player 재생을 멈춰준다.
          this.$store.dispatch('setIsPlayerForceStop', !this.$store.getters.isPlayerForceStop)

          // 섹션이 없으면 섹션 하나를 바로 생성해서 녹화 진행
          if (
            this.totalSectionList === undefined ||
            this.totalSectionList === null ||
            this.totalSectionList.length <= 0
          ) {
            this.sectionTitle = this.$t('unTitledSection')
            this.startRecordSetting()
          } else {
            // 녹화 진행
            this.startRecordSetting()
          }
        } else {
          this.$store.dispatch('setSignInRedirectUrl', location.pathname)
          this.$router.push({ name: 'SignIn' })
        }
      }
    },
    startRecordSetting() {
      // Follow Up Item 이 있는 경우
      // if (
      //   this.followUpItem &&
      //   this.followUpItem !== null &&
      //   this.userInfo.userId !== this.followUpItem.clipUploader.userId
      // ) {
      //   this.deleteFollowUpVisible = true
      // } else {
      this.floatingState = State.RecordSetting
      this.checkPermission(null)
      // }
    },
    startRecord() {
      this.floatingState = State.Recording

      this.isRecordPause = false
      this.isMuted = !this.isIncludeAudio

      this.$store.dispatch('setFirebaseLog', {
        eventName: 'start_recording',
        eventParam: {
          methodType: this.getRecordType(),
        },
      })

      setTimeout(() => {
        if (this.getRecordType() === 'audio') {
          this.$refs.audioRecorder.startRecord()
        } else if (this.getRecordType() === 'screen') {
          this.$refs.screenAndMediaRecorder.startRecord()
        } else if (this.getRecordType() === 'face') {
          this.$refs.mediaRecorder.startRecord()
        }

        this.$refs.timer.startTimer()
      }, 200)
    },
    pauseResumeRecord(isPause, isClear) {
      this.isRecordPause = isPause

      if (this.getRecordType() === 'audio') {
        this.$refs.audioRecorder.pauseResumeRecord(isClear)
      } else if (this.getRecordType() === 'screen') {
        this.$refs.screenAndMediaRecorder.pauseResumeRecord(isClear)
      } else if (this.getRecordType() === 'face') {
        this.$refs.mediaRecorder.pauseResumeRecord(isClear)
      }
    },
    pauseResumeSttRecord(isPause) {
      if (this.getRecordType() === 'audio') {
        this.$refs.audioRecorder.sttRecorderPauseAndResume(isPause)
      } else if (this.getRecordType() === 'screen') {
        this.$refs.screenAndMediaRecorder.sttRecorderPauseAndResume(isPause)
      } else if (this.getRecordType() === 'face') {
        this.$refs.mediaRecorder.sttRecorderPauseAndResume(isPause)
      }
    },
    completeRecord() {
      this.$refs.timer.stopTimer(false)

      if (this.getRecordType() === 'audio') {
        this.$refs.audioRecorder.completeRecord()
      } else if (this.getRecordType() === 'screen') {
        this.$refs.screenAndMediaRecorder.completeRecord()
      } else if (this.getRecordType() === 'face') {
        this.$refs.mediaRecorder.completeRecord()
      }
    },

    stopSharing(isRecord) {
      if (isRecord) this.completeRecord()
      else this.discardPreview()
    },

    saveBlob(blobData) {
      if (blobData !== undefined && blobData !== null) {
        this.blob = blobData.blob
        this.audioBlobs = blobData.audioBlobs
        this.audioSilenceList = blobData.audioSilenceList
        this.duration = blobData.duration
      }
      this.floatingState = State.Preview
    },
    checkAudioDisabled() {
      if (this.isIncludeAudio && this.isAudioDisabled) {
        this.isAudioNotAvailableDialog = true
      } else {
        this.countDown()
      }
    },
    countDown() {
      if (this.getRecordType() !== null && this.countDownTimer === null) {
        this.floatingState = State.CountDown
        // 스크린 녹화일 경우 처음 끊기는 현상 제거를 위해 trick 설정
        if (this.getRecordType() === 'screen') this.$refs.screenAndMediaRecorder.startRecordTrick()
        else this.finishRecordTrick()
      }
    },
    restart() {
      this.discardRecording()
      setTimeout(() => {
        this.checkAudioDisabled()
      }, 1)
    },
    async finishRecordTrick() {
      this.audio.addEventListener('ended', this.countDownEnd)
      return await new Promise(() => {
        this.countDownTimer = setInterval(() => {
          // if (!this.isCountDownPause) {
          if (this.timeLeft === 1) this.audio.play()
          this.timeLeft--
          // }
        }, 1000)
      })
    },
    countDownEnd() {
      this.skipCountDown()
      this.audio.removeEventListener('ended', this.countDownEnd)
    },
    countDownCancel() {
      this.clearTimeout()
      this.recordSetting()
    },
    skipCountDown() {
      this.clearTimeout()
      this.startRecord()
    },
    clearTimeout() {
      if (this.countDownTimer !== null) clearTimeout(this.countDownTimer)
      if (this.preparingTimeout !== null) clearTimeout(this.preparingTimeout)
      this.timeLeft = 3
      // this.isCountDownPause = false
      this.countDownTimer = null
      this.preparingTimeout = null
    },
    uploadFinish(failedType) {
      // this.isShowProgressDialog = false
      if (failedType) {
        // this.$emit('uploadFinish')
        this.discardPreview()
      }
    },
    getRecordType() {
      if (this.isUploadClip) {
        return 'upload'
      } else if (this.isIncludeScreen) {
        return 'screen'
      } else if (this.isIncludeFace) {
        return 'face'
      } else if (this.isIncludeAudio) {
        return 'audio'
      } else {
        return null
      }
    },
    closeUploadVideo() {
      this.isUploadClip = false
      // this.floatingState = State.RecordSetting
      this.discardPreview()
    },
    startAnalyser() {
      // this.$nextTick(() => {
      this.stopAnalyser()

      // mic 입력에 대한 stream 값 사용 여부
      let isAvailableMicStream = this.micStream && this.micStream.getAudioTracks().length > 0
      // mic + system audio 입력에 대한 stream 값 사용 여부
      let isAvailableMediaStream = this.mediaStream && this.mediaStream.getAudioTracks().length > 0

      // mic or system audio 가 들어온다면 analyser 를 실행해준다.
      if (isAvailableMicStream || isAvailableMediaStream) {
        // mic 측정을 위한 변수
        let micCtx, micAnalyser, micSource, micBufferLengthAlt, micDataArrayAlt
        // system audio 측정을 위한 변수
        let mediaCtx, mediaAnalyser, mediaSource, mediaBufferLengthAlt, mediaDataArrayAlt

        // mic 측정을 진행한다면
        if (isAvailableMicStream) {
          micCtx = new (window.AudioContext || window.webkitAudioContext)()
          micAnalyser = micCtx.createAnalyser()
          if (!micAnalyser) return
          micAnalyser.fftSize = 32
          micSource = micCtx.createMediaStreamSource(this.micStream)
          micSource.connect(micAnalyser)

          micBufferLengthAlt = micAnalyser.frequencyBinCount
          micDataArrayAlt = new Uint8Array(micBufferLengthAlt)
        }
        // system audio 측정을 진행한다면
        if (isAvailableMediaStream) {
          mediaCtx = new (window.AudioContext || window.webkitAudioContext)()
          mediaAnalyser = mediaCtx.createAnalyser()
          if (!mediaAnalyser) return
          mediaAnalyser.minDecibels = -50
          mediaSource = mediaCtx.createMediaStreamSource(this.mediaStream)
          mediaSource.connect(mediaAnalyser)

          mediaBufferLengthAlt = mediaAnalyser.frequencyBinCount
          mediaDataArrayAlt = new Uint8Array(mediaBufferLengthAlt)
        }
        this.audioCheckInterval = setInterval(() => {
          // mic 측정
          if (isAvailableMicStream) {
            micAnalyser.getByteFrequencyData(micDataArrayAlt)
            let micSum = micDataArrayAlt.reduce((sum, currValue) => {
              return sum + currValue
            })
            this.isAudioDisabled = micSum <= 0
            if (micSum <= 0 && !this.noAudioDetectTimeOut && this.isIncludeAudio && !this.isMuted) {
              this.setNoAudioDetectNoti()
            } else if (micSum > 0 && this.noAudioDetectTimeOut) {
              clearTimeout(this.noAudioDetectTimeOut)
              this.noAudioDetectTimeOut = null
            }
          }
          // system audio 측정
          if (isAvailableMediaStream) {
            mediaAnalyser.getByteFrequencyData(mediaDataArrayAlt)
            let mediaSum = mediaDataArrayAlt.reduce((sum, currValue) => {
              return sum + currValue
            })
            // console.log('mediaSum ', mediaSum)

            if (mediaSum <= 0 && !this.noSttAudioDetectTimeOut) {
              this.noSttAudioDetectTimeOut = setTimeout(() => {
                this.pauseResumeSttRecord(true)
                clearTimeout(this.noSttAudioDetectTimeOut)
              }, 5000)
            } else if (mediaSum > 0) {
              if (this.noSttAudioDetectTimeOut) {
                clearTimeout(this.noSttAudioDetectTimeOut)
                this.noSttAudioDetectTimeOut = null
              }
              this.pauseResumeSttRecord(false)
            }
          }
        }, 50)
      }
      // })
    },
    stopAnalyser() {
      if (this.audioCheckInterval) {
        clearInterval(this.audioCheckInterval)
        this.audioCheckInterval = null
      }
      if (this.noAudioDetectTimeOut) {
        clearTimeout(this.noAudioDetectTimeOut)
        this.noAudioDetectTimeOut = null
      }
      if (this.noSttAudioDetectTimeOut) {
        clearTimeout(this.noSttAudioDetectTimeOut)
        this.noSttAudioDetectTimeOut = null
      }
    },
    setNoAudioDetectNoti() {
      this.noAudioDetectTimeOut = setTimeout(() => {
        if (this.isAvailableMic) {
          // notify(this, 'Error', this.$t('noAudioDetectedNoti'), 'error')

          const content = {
            component: Toast,
            props: {
              msg: this.$t('noAudioDetectedNoti'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
          clearTimeout(this.noAudioDetectTimeOut)
        }
      }, 3000)
    },
  },
  beforeDestroy() {
    this.stopAnalyser()
    if (this.chkFinishMtLoadingInterval) {
      clearInterval(this.chkFinishMtLoadingInterval)
      this.chkFinishMtLoadingInterval = null
    }
    window.removeEventListener('resize', this.resize)
  },
  watch: {
    floatingState(to, from) {
      if (to === State.Normal) {
        this.clearTimeout()
        if (this.blob !== null) this.blob = null
        if (this.audioBlobs !== null) this.audioBlobs = null
        if (this.audioSilenceList !== null) this.audioSilenceList = null

        this.summaryTopics = null
        this.summaryTemplate = null
      } else if (to === State.RecordSetting && from !== State.Normal) {
        // if (this.audioStream !== undefined && this.audioStream !== null && this.isIncludeAudio) {
        //   this.startAnalyser()
        // }
      } else if (to === State.CountDown) {
        if (!this.preparingTimeout) {
          this.preparingTimeout = setTimeout(() => {
            if (
              this.floatingState === State.CountDown &&
              (this.countDownTimer === undefined || this.countDownTimer === null)
            ) {
              // notify(this, 'Error', this.$t('general.error'), 'error')

              const content = {
                component: Toast,
                props: {
                  msg: this.$t('general.error'),
                  // submsg: '',
                },
              }
              this.$toast.error(content)
              this.discardPreview()
            }
          }, 3000)
        }
      }

      // 녹화화면 Container 값 계산을 위해 호출
      if (to === State.RecordSetting) {
        setTimeout(() => {
          this.resize()
        }, 100)
      }
    },
    recordType: {
      // immediate: true,
      deep: true,
      handler(val) {
        // 녹화 Preference 저장
        localStorage.setItem('recordType', JSON.stringify(val))
      },
    },
    isIncludeAudio(val) {
      this.isMuted = !val
    },
    isRequestVideoType(val) {
      if (val === 'text' || val === 'upload' || val === 'embed' || val === 'poll') this.changeRecordType(val)
      else if (val !== null) this.recordSetting()
    },
    requestSaveBlob(val) {
      if (val && val !== null) {
        this.saveBlob(val)
      }
    },
    isMuted(val) {
      if (!val) {
        this.startAnalyser()
      } else {
        // this.stopAnalyser()
      }
    },
  },
}
</script>

<style scoped>
h1 {
  font-size: 10em;
  font-weight: bold;
  color: white;
}
.txt-preparing {
  font-size: 3em;
  font-weight: bold;
  color: white;
}
.start-meeting-active {
  background-color: transparent !important;
  border-color: transparent !important;
  color: white !important;
  /* width: 300px; */
  /* font-size: 0.8rem; */
}
.start-meeting-inActive {
  background-color: transparent !important;
  border-color: transparent !important;
  color: white !important;
}

.dialog >>> .el-dialog {
  background-color: transparent;
}

.dialog >>> .el-dialog__body {
  background: #21343b !important;
  min-width: 250px;
  max-width: 250px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.dialog >>> .el-dialog__header {
  background: #21343b !important;
  background-color: transparent;
  min-width: 250px;
  max-width: 250px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.dialog >>> .el-dialog__title {
  color: white;
  min-width: 250px;
  max-width: 250px;
}

.access-dialog >>> .el-dialog {
  background-color: transparent;
}

.access-dialog >>> .el-dialog__body span {
  display: table;
  margin: 0 auto;
}

.access-dialog >>> .el-dialog__header {
  background: #21343b !important;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.access-dialog >>> .el-dialog__body {
  background: #21343b !important;
  align-self: center;
  color: #96a7af;
}

.access-dialog >>> .el-dialog__footer {
  background: #21343b !important;
  color: white;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.access-dialog >>> .el-dialog__title {
  color: white;
}

.col-1 {
  cursor: pointer;
}

.v-avatar {
  cursor: pointer;
  width: 50px !important;
  height: 50px !important;
  min-width: 0px !important;
}
.container-v-btn >>> .v-btn * {
  font-size: 14px;
  color: white;
  letter-spacing: 0;
  text-transform: none;
  font-weight: bold;
}
.record-layout >>> .v-btn * {
  font-size: 14px;
  color: white;
  letter-spacing: 0;
  text-transform: none;
  font-weight: bold;
}
.floating-menu >>> .v-btn * {
  font-size: 14px;
  color: white;
  letter-spacing: 0;
  text-transform: none;
  font-weight: bold;
}
.row {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}
/* .layoutController {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0px;
  background-color: #21343b;
} */
.wrap-plus-noti {
  position: fixed;
  font-size: 15px;
  font-weight: 600;
  top: 20px;
  width: 100%;
  max-width: 600px;
  left: calc(50% - 300px);
  color: #ccc;
  background-color: #0b1214;
  border-radius: 15px;
  padding: 12px;
  z-index: 1;
}
.txt-plus-noti {
  display: inline-flex;
  padding-left: 5px;
}
.btn-plus-noti {
  border-radius: 10px;
}
@media (max-width: 600px) {
  .wrap-plus-noti {
    top: 0px;
    font-size: 13px;
    width: 100%;
    left: 0;
    padding: 0px;
  }
  .txt-plus-noti {
    padding: 5px 0 8px 0;
  }
  .btn-plus-noti {
    margin-bottom: 10px;
  }
  .btn-plus-noti >>> span {
    font-size: 12px;
  }
}
.wrap-btn-record,
.wrap-btn-recording {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.wrap-btn-preview >>> button,
.wrap-btn-record >>> button,
.wrap-btn-recording >>> button {
  width: 50px;
}
.wrap-btn-preview >>> button span,
.wrap-btn-record >>> button span,
.wrap-btn-recording >>> button span {
  display: flex;
  flex-direction: column;
}
.wrap-btn-preview >>> button span.btn-text,
.wrap-btn-record >>> button span.btn-text,
.wrap-btn-recording >>> button span.btn-text {
  color: #96a7af;
  font-weight: 400;
}
.floating-menu >>> button.v-btn.v-btn--disabled {
  background-color: transparent !important;
}
.v-tab {
  text-transform: none;
  letter-spacing: 0;
  padding: 0 8px;
  background-color: #21343b;
  font-size: 13px;
  border-radius: 3px;
  margin: 0 2px;
}
.v-tab.v-tab--active {
  background-color: #31434f;
}
.v-tabs >>> .v-slide-group__prev {
  flex: 0 1 36px !important;
  min-width: 36px !important;
}
.v-tabs >>> .v-slide-group__next {
  flex: 0 1 36px !important;
  min-width: 36px !important;
}
.v-item-group.v-tabs-items {
  background-color: transparent;
  height: 100%;
}

.wrap-video {
  display: flex;
  flex-direction: column;
  width: calc(100% - 260px);
}

.wrap-non-video {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.wrap-video-preview {
  display: flex;
  flex-direction: column;
  width: calc(100% - 260px);
}

.all-off-layout {
  color: #ddd;
}
.all-off-title {
  font-size: 20px;
  font-weight: 600;
}
.all-off-desc {
  font-size: 14px;
  color: #96a7af;
}
.btn-record-outer {
  width: 40px;
  height: 40px;
  border-radius: 100%;
  box-shadow: 0 0 0 3px #fff;
}
.btn-record-inner {
  width: 80%;
  height: 80%;
  margin: 10%;
  border-radius: 100%;
  background-color: #ff464f;
}
.btn-record-complete-outer {
  width: 40px;
  height: 40px;
  border-radius: 100%;
  box-shadow: 0 0 0 3px #ff464f;
  animation: ease pulse-shadow 2s infinite;
}
.btn-record-complete-inner {
  width: 40%;
  height: 40%;
  margin: 30%;
  border-radius: 3px;
  background-color: #ff464f;
  animation: ease pulse 2s infinite;
}
.line-border {
  border: 1px solid #475e69;
  border-radius: 5px;
}
.fs-40 {
  font-size: 40px !important;
}
.fs-30 {
  font-size: 30px !important;
}
.fw-400 {
  font-weight: 400 !important;
}
.color-gray {
  color: #ccd7db !important;
}
.color-green {
  color: rgb(59, 194, 140) !important;
}
.bgcolor-transparent {
  background-color: transparent !important;
}
@keyframes pulse {
  0% {
    background-color: #ff464f;
  }
  50% {
    background-color: #eb7e7e;
  }
  100% {
    background-color: #ff464f;
  }
}
@keyframes pulse-shadow {
  0% {
    box-shadow: 0 0 0 3px #ff464f;
  }
  50% {
    box-shadow: 0 0 0 3px #eb7e7e;
  }
  100% {
    box-shadow: 0 0 0 3px #ff464f;
  }
}
.v-tooltip__content {
  z-index: 205 !important;
}
.warp-script-layout {
  width: 100%;
  max-width: 350px;
  margin-left: 16px;
  overflow: hidden;
}
/* @media (max-width: 959px) {
  .warp-script-layout {
    width: 100%;
    margin-left: 16px;
    overflow: hidden;
  }
} */
</style>
